import { WifiOff } from "lucide-react";
import { publicAsset } from "../../features/tenantPath";
import Auticko from "../Auticko/Auticko";
import "./TenantGate.scss";

/**
 * Celostrankove hlasenie namiesto obsahu prevadzky:
 *   notFound -- slug / domena nepatri ziadnej prevadzke
 *   expired  -- demo (alebo ina) prevadzka ma vyprsanu platnost
 *   error    -- backend nedostupny; s moznostou skusit znova
 *
 * Odkaz "na rozvozy.sk" je obycajny <a>, nie <Link> -- vedie mimo basename
 * aktualnej prevadzky.
 *
 * Bez ikony (Icon: null) sa ukaze stojace auticko. Pri chybe spojenia ikona
 * ostava -- WifiOff hovori, co sa deje, auticko by nepovedalo nic.
 */
const OBSAH = {
  notFound: {
    Icon: null,
    title: "Prevádzka neexistuje",
    text: "Na tejto adrese nie je žiadna prevádzka. Skontrolujte odkaz, ktorý ste dostali.",
  },
  expired: {
    Icon: null,
    title: "Platnosť prevádzky vypršala",
    text: "Táto prevádzka už nie je aktívna. Ak ide o vašu demo prevádzku a chcete pokračovať, ozvite sa nám.",
  },
  error: {
    Icon: WifiOff,
    title: "Nepodarilo sa načítať prevádzku",
    text: "Server momentálne neodpovedá. Skúste to o chvíľu znova.",
  },
};

function TenantGate({ variant, tenant = null, onRetry = null }) {
  const { Icon, title, text } = OBSAH[variant] || OBSAH.error;
  const nazov = tenant?.branding?.display_name || tenant?.name;

  return (
    <main className="tenant-gate">
      <div className="tenant-gate__card">
        <img className="tenant-gate__logo" src={publicAsset("rozvozy_icon.png")} height="40" alt="Rozvozy" />
        {Icon
          ? <Icon className="tenant-gate__icon" size={40} aria-hidden="true" />
          : <Auticko sirka={110} className="tenant-gate__auto" />}
        <h1 className="tenant-gate__title">{title}</h1>
        {nazov && <p className="tenant-gate__name">{nazov}</p>}
        <p className="tenant-gate__text">{text}</p>
        <div className="tenant-gate__actions">
          {onRetry && (
            <button type="button" className="tenant-gate__btn tenant-gate__btn--primary" onClick={onRetry}>
              Skúsiť znova
            </button>
          )}
          <a className="tenant-gate__btn" href="https://rozvozy.sk/">
            Prejsť na rozvozy.sk
          </a>
        </div>
      </div>
    </main>
  );
}

export default TenantGate;
